function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.4854 17.0049L2.47038 0H1.7539L1.6076 0.371523C1.22147 1.35215 1.05649 2.35511 1.13056 3.27187C1.21498 4.31687 1.61221 5.22159 2.27937 5.88835L9.43637 13.0411L10.3804 12.0976L16.997 19.4919C17.6552 20.1497 18.7881 20.1888 19.4854 19.4919C20.1715 18.8062 20.1715 17.6906 19.4854 17.0049Z",
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.11986 11.3844L0.514526 16.9864C-0.171509 17.672 -0.171509 18.7877 0.514526 19.4733C1.16624 20.1247 2.29367 20.1822 3.00292 19.4733L8.6083 13.8713L6.11986 11.3844Z",
  fill: "#6F62FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.156 3.33003L15.9763 6.50776L15.1468 5.67878L18.3264 2.50101L17.497 1.67203L14.3173 4.84976L13.4879 4.02078L16.6675 0.843046L15.8381 0.0141015L11.6907 4.15902C11.1833 4.66609 10.8804 5.33937 10.8375 6.05491C10.8267 6.2362 10.7856 6.41452 10.7174 6.58413L13.4115 9.27667C13.5812 9.20842 13.7597 9.16737 13.9411 9.15655C14.657 9.11385 15.3307 8.811 15.8381 8.30393L19.9855 4.15906L19.156 3.33003Z",
  fill: "#6F62FF"
});

var SvgNutrition = function SvgNutrition(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNutrition, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nutrition.b9ae5692.svg";
export { ForwardRef as ReactComponent };